import { render, staticRenderFns } from "./APKudos.vue?vue&type=template&id=1a27e266&"
import script from "./APKudos.vue?vue&type=script&lang=js&"
export * from "./APKudos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports